import { isMobileOnly } from 'react-device-detect';
import { trackRegistrationConversion } from '@shared/utils/tracker';
import { LSK } from '@shared/utils/storage/config';

import { NoneBusinessDependency } from './dependency';

import eventTracker, { LoggingAction } from '@shared/utils/event/newDataWareHose';
import { useUserCreate } from '@shared/stores/User';
import { tryParseJson } from '@shared/utils/json';

import { EVENT2URL, EVENT3URL, EVENT4URL } from './types';

//新注册用户取消每日登录
export function lockNewUserLoginDaily(userId: string) {
	const localKey = LSK.LAST_LOGIN_DATE + userId.slice(-5);
	const currentDate = new Date().toISOString().split('T')[0];
	localStorage.setItem(localKey, currentDate);
}

export const registerSuccessHandle = (data: any, url: string) => {
	const preUserId = useUserCreate.getState().getUserId();
	const registerTypeMap: Record<string, string> = {
		[EVENT2URL.registerSuccess]: 'email',
		[EVENT2URL.googleLoginSuccess]: 'google',
		[EVENT2URL.phoneLoginSuccess]: 'phone',
		[EVENT2URL.facebookLoginSuccess]: 'facebook',
		[EVENT2URL.touristLoginSuccess]: 'tourist',
	};

	const userData = data.data;
	const currentUserId = userData?.userId || '';
	//积分激励
	lockNewUserLoginDaily(currentUserId);
	// 追踪注册转化
	trackRegistrationConversion();
	const registerType = registerTypeMap[url];

	NoneBusinessDependency.trackUserRegister({
		method: registerType,
		user_id: currentUserId,
		is_visitor: userData?.tourist || false,
	});

	registerType !== 'tourist' &&
		eventTracker.loggingEvent(LoggingAction.REGISTRATION_POP_UP, {
			method: registerType,
			user_id: currentUserId,
			isregister: 'register',
		});

	eventTracker.loggingEvent(LoggingAction.LOGIN_SUCCESS, {
		type: 'sign_up',
		method: registerType,
		pre_user_id: preUserId,
		visitor_bind: userData?.newBind || false,
		is_visitor: userData?.tourist || false,
	});
	eventTracker.updateChannel(location.search, true);
};

export const loginSuccessHandle = (data: any, url: string) => {
	const preUserId = useUserCreate.getState().getUserId();
	const loginTypeMap: Record<string, string> = {
		[EVENT3URL.loginSuccess]: 'email',
		[EVENT3URL.googleLoginSuccess]: 'google',
		[EVENT3URL.phoneLoginSuccess]: 'phone',
		[EVENT3URL.facebookLoginSuccess]: 'facebook',
		[EVENT3URL.touristLoginSuccess]: 'tourist',
	};
	const userData = data.data;

	const currentUserId = userData?.userId || '';

	const loginType = loginTypeMap[url];

	eventTracker.loggingEvent(LoggingAction.AUTOLOGIN, {
		user_id: currentUserId,
		method: loginType,
		is_visitor: userData?.tourist || false,
	});
	loginType !== 'tourist' &&
		eventTracker.loggingEvent(LoggingAction.REGISTRATION_POP_UP, {
			method: loginType,
			user_id: currentUserId,
			isregister: 'register',
		});

	// 发登录成功事件
	// userEvent.emitLogin({ userId: currentUserId });
	NoneBusinessDependency.emitLogin({ userId: currentUserId });

	eventTracker.loggingEvent(LoggingAction.LOGIN_SUCCESS, {
		type: 'login',
		method: loginType,
		pre_user_id: preUserId,
		visitor_bind: userData?.newBind || false,
		is_visitor: userData?.tourist || false,
	});
	eventTracker.updateChannel(location.search, true);
	if (userData?.isLoginFromFreeze) {
		// Track.action.stop_account_delete({});
		NoneBusinessDependency.stopAccountDelete();
	}
};

export const imageSuccessHandle = (url: string, config: any) => {
	const generateUrl = [EVENT4URL.generateSuccess, EVENT4URL.generateSuccess2];
	if (isMobileOnly) return;
	if (generateUrl.indexOf(url as EVENT4URL) !== -1) {
		let type = undefined;
		if (url === EVENT4URL.generateSuccess) {
			type = 'test';
		} else if (url === EVENT4URL.generateSuccess2) {
			type = 'generate';
		}
		if (!('preference' in tryParseJson(config.data))) {
			eventTracker.loggingEvent(LoggingAction.GENERATE_BUTTON_CLICK, {
				type: type,
				appId: JSON.parse(config.data)?.appId,
				LSKType: LSK.GENERATE_BUTTON_CLICK_PROPS,
				credit: 1,
				multiple: 1,
			});
		}
		return;
	}
};
